<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="业务类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.bizType" allowClear style="width: 100%">
                    <a-select-option value="annual_fee">功能年费</a-select-option>
                    <a-select-option value="bill_pay">订单支付</a-select-option>
                    <a-select-option value="member_mall">会员商城</a-select-option>
                    <a-select-option value="monthly_bill">月结账单</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="支付状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.payStatus" allowClear style="width: 100%">
                    <a-select-option value="0">待支付</a-select-option>
                    <a-select-option value="1">成功</a-select-option>
                    <a-select-option value="2">失败</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="12" :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <section>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            @change="handleTableChange">
            <template slot="bizType" slot-scope="text">
              <span>{{ bizTypeName(text) }}</span>
            </template>
            <template slot="payStatus" slot-scope="text">
              <a-tag v-if="text === '1'" color="green">成功</a-tag>
              <a-tag v-else-if="text === '2'" color="red">失败</a-tag>
              <a-tag v-else color="orange">待支付</a-tag>
            </template>
            <template slot="refundState" slot-scope="text, record">
              <a-tag v-if="text === '2'" color="red">全额退款</a-tag>
              <a-tag v-else-if="text === '1'" color="orange">
                部分({{ (Number(record.refundAmount) / 100).toFixed(2) }})
              </a-tag>
              <span v-else>-</span>
            </template>
            <template slot="action" slot-scope="text, record">
              <a
                v-if="record.payStatus === '1' && record.bizType !== 'annual_fee' && record.refundState !== '2'"
                @click="openRefund(record)"
              >退款</a>
              <span v-else>-</span>
            </template>
          </a-table>
        </section>
        <a-pagination
          style="margin-top: 16px; text-align: right"
          :current="ipagination.current"
          :pageSize="ipagination.pageSize"
          :total="ipagination.total"
          @change="paginationChange"
          @showSizeChange="paginationShowSizeChange"
        />
        <a-modal
          v-model="refundVisible"
          title="申请退款"
          :confirmLoading="refundLoading"
          @ok="submitRefund"
        >
          <a-form :labelCol="{ span: 6 }" :wrapperCol="{ span: 15 }">
            <a-form-item label="支付单号">
              <span>{{ refundRecord.payOrderNo }}</span>
            </a-form-item>
            <a-form-item label="支付金额(元)">
              <span>{{ (Number(refundRecord.amount) / 100).toFixed(2) }}</span>
            </a-form-item>
            <a-form-item label="已退金额(元)">
              <span>{{ (Number(refundRecord.refundAmount || 0) / 100).toFixed(2) }}</span>
            </a-form-item>
            <a-form-item label="退款金额(元)" required>
              <a-input-number
                v-model="refundForm.amount"
                :min="0.01"
                :precision="2"
                :max="maxRefundAmount"
                style="width: 100%"
              />
            </a-form-item>
            <a-form-item label="退款原因">
              <a-textarea v-model="refundForm.reason" :rows="2" :maxLength="200" placeholder="选填" />
            </a-form-item>
          </a-form>
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getPayOrders, refundPayOrder } from '@/api/plugin/orderReceive'

export default {
  name: 'PayOrderList',
  mixins: [JeecgListMixin],
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      urlPath: '/plugin/order-receive/payorder',
      queryParam: {
        bizType: '',
        payStatus: ''
      },
      refundVisible: false,
      refundLoading: false,
      refundRecord: {},
      refundForm: {
        amount: null,
        reason: ''
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '支付单号',
          dataIndex: 'payOrderNo',
          width: 200
        },
        {
          title: '租户ID',
          dataIndex: 'tenantId',
          width: 90,
          align: 'center'
        },
        {
          title: '业务类型',
          dataIndex: 'bizType',
          width: 110,
          align: 'center',
          scopedSlots: { customRender: 'bizType' }
        },
        {
          title: '业务单据ID',
          dataIndex: 'bizId',
          width: 100,
          align: 'center'
        },
        {
          title: '金额(元)',
          dataIndex: 'amount',
          width: 110,
          align: 'right',
          customRender: function(text) {
            const num = Number(text)
            return isNaN(num) ? '0.00' : (num / 100).toFixed(2)
          }
        },
        {
          title: '支付方式',
          dataIndex: 'wayCode',
          width: 110,
          align: 'center'
        },
        {
          title: '支付状态',
          dataIndex: 'payStatus',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'payStatus' }
        },
        {
          title: '退款状态',
          dataIndex: 'refundState',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'refundState' }
        },
        {
          title: 'Jeepay订单号',
          dataIndex: 'jeepayPayOrderId',
          width: 180
        },
        {
          title: '下单时间',
          dataIndex: 'createTime',
          width: 160
        },
        {
          title: '回调时间',
          dataIndex: 'notifyTime',
          width: 160
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 80,
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/plugin/order-receive/pay-orders'
      }
    }
  },
  computed: {
    // 可退上限（元）= 支付金额 - 已退金额
    maxRefundAmount() {
      const amount = Number(this.refundRecord.amount) || 0
      const refunded = Number(this.refundRecord.refundAmount) || 0
      return Math.max(0, (amount - refunded) / 100)
    }
  },
  methods: {
    bizTypeName(text) {
      const map = { annual_fee: '功能年费', bill_pay: '订单支付', monthly_bill: '月结账单', member_mall: '会员商城' }
      return map[text] || text
    },
    getQueryParams() {
      return {
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        bizType: this.queryParam.bizType || '',
        payStatus: this.queryParam.payStatus || ''
      }
    },
    paginationChange(current, pageSize) {
      this.ipagination.current = current
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, pageSize) {
      this.ipagination.current = 1
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    openRefund(record) {
      this.refundRecord = record
      this.refundForm.amount = this.maxRefundAmount
      this.refundForm.reason = ''
      this.refundVisible = true
    },
    submitRefund() {
      if (!this.refundForm.amount || this.refundForm.amount <= 0) {
        this.$message.warning('请输入退款金额')
        return
      }
      this.refundLoading = true
      refundPayOrder({
        payOrderNo: this.refundRecord.payOrderNo,
        amount: this.refundForm.amount,
        reason: this.refundForm.reason || undefined
      }).then(res => {
        if (res.success) {
          this.$message.success('退款已发起，结果以退款状态为准')
          this.refundVisible = false
          this.loadData()
        } else {
          this.$message.warning(res.message || '退款失败')
        }
      }).finally(() => {
        this.refundLoading = false
      })
    }
  }
}
</script>
<style scoped>
.table-page-search-wrapper { margin-bottom: 15px; }
</style>
